<template>
  <div>
    <b-overlay variant="light" opacity=".3" blur="2px" :show="show_overlay">
      <b-row>
        <b-col cols="3">
          <b-form-group label="Cep:">
            <b-form-input
              v-model="cepModel"
              placeholder="Cep"
              :state="validateState('cep')"
              @keypress="onlyNumbers($event)"
              maxlength="10"
              :size="size"
            />
            <b-form-invalid-feedback>
              <span v-if="!$v.value.cep.required">
                O CEP é um campo obrigatório.
              </span>

              <span v-if="!$v.value.cep.minLength">
                campo CEP requer um mínimo de 8 caracteres.
              </span>

              <span v-if="!$v.value.cep.maxLength">
                O campo CEP requer um máximo de 8 caracteres.
              </span>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Estado:">
            <select-estado
              v-model="value.estado_sigla"
              ref="selecEstado"
              :size="size"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Cidade:">
            <select-municipio
              v-model="value.id"
              :uf="value.estado_sigla"
              :state="validateState('cidade_id')"
              ref="selecCidade"
              :size="size"
            />
            <b-form-invalid-feedback :state="validateState('cidade_id')">
              Cidade é um campo obrigatório.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { mapActions } from "vuex";
import { merge } from "lodash";
import { createCepFetcher } from "@/helpers/functions/findCep";

export default {
  mixins: [validationMixin],
  props: {
    value: {
      type: Object,
      default: () => ({
        estado_sigla: "",
        cidade_id: "",
      }),
    },
    cep: {
      type: [String, Number],
      default: "",
    },
    size: {
      type: String,
      default: "md",
    },
    cepDebounce: {
      type: Number,
      default: 500,
    },
  },
  data: () => ({
    show_overlay: false,
    cepFetcher: null,
  }),
  validations: {
    value: {
      cep: {},
      logradouro: {},
      numero: {},
      bairro: {},
      cidade_id: {},
    },
  },

  computed: {
    cepModel: {
      set(value) {
        value = value.replace(/\D/g, "").substring(0, 8);

        this.$emit("update:cep", value);
      },
      get() {
        let value = "";
        if (this.cep) {
          value = this.cep.replace(/^(\d{2})(\d{3})(\d{3})/, "$1.$2-$3");
        }
        return value;
      },
    },
  },
  methods: {
    ...mapActions("municipios", ["ActionFindById"]),
    validateState(name) {
      const { $dirty, $error } = this.$v.value[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.value.$touch();
      return !this.$v.value.$anyError;
    },
    onlyNumbers(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
  watch: {
    "value.id": {
      deep: true,
      handler: function (value) {
        if (this.$refs["selecCidade"]) {
          const cidade = this.$refs["selecCidade"].municipio;

          if (cidade) {
            this.$refs["selecEstado"].setBySigla(cidade.estado_sigla);
          }
        }
      },
    },
    cepModel: function (value = "") {
      this.cepFetcher = createCepFetcher({
        debounceMs: this.cepDebounce,
        onLoadingChange: (status) => {
          this.show_overlay = status;
        },
        onSuccess: (response) => {
          if (response?.ibge) {
            this.value.id = response?.ibge;
          }

          if (response?.localidade) {
            this.value.nome = response?.localidade;
          }
        },
        onError: (error) => console.log(error),
      });

      this.cepFetcher?.(value);
    },
  },
  created() {
    const endereco = merge(
      {
        id: null,
        nome: "",
        estado_sigla: "",
        capital: false,
        info: null,
      },
      this.value ? this.value : {}
    );

    this.$emit("input", endereco);
  },
  beforeDestroy() {
    this.cepFetcher?.cancel?.();
  },
};
</script>
